import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RequireAuth } from "@/components/RequireAuth";
import { SiteTranslator } from "@/components/SiteTranslator";
import { ChallengeHost } from "@/components/ChallengeHost";
import Upgrade from "@/pages/Upgrade";
import Scan from "@/pages/Scan";
import PaymentResult from "@/pages/PaymentResult";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";
import Favorites from "@/pages/Favorites";
import PhotoRizz from "@/pages/PhotoRizz";
import Legal from "@/pages/Legal";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";

export default function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/onboarding" element={<RequireAuth onboarded={false}><Onboarding /></RequireAuth>} />
            <Route path="/app" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/photo-rizz" element={<RequireAuth><PhotoRizz /></RequireAuth>} />
            <Route path="/scan" element={<RequireAuth><Scan /></RequireAuth>} />
            <Route path="/payment/:status" element={<RequireAuth><PaymentResult /></RequireAuth>} />
            <Route path="/upgrade" element={<RequireAuth><Upgrade /></RequireAuth>} />
            <Route path="/favorites" element={<RequireAuth><Favorites /></RequireAuth>} />
            <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
            <Route path="/admin" element={<RequireAuth><Admin /></RequireAuth>} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" richColors />
        <SiteTranslator />
        <ChallengeHost />
      </AuthProvider>
    </ThemeProvider>
  );
}
